import { useCallback } from 'react'

import { useDisconnectSlackIntegrationPresenter } from '@webapp/platform/integrations/features/disconnect-slack-integration'
import { useGetSlackIntegrationConfigPresenter } from '@webapp/platform/integrations/features/get-slack-integration-config'

export const useSlackIntegrationSection = () => {
  const { isIntegrated, oauthUrl, isLoading, error } =
    useGetSlackIntegrationConfigPresenter()

  const {
    commands: { handleDisconnect },
    states: { isDisconnecting },
  } = useDisconnectSlackIntegrationPresenter()

  const handleConnect = useCallback(() => {
    globalThis.location.href = oauthUrl
  }, [oauthUrl])

  return {
    isIntegrated,
    handleConnect,
    handleDisconnect,
    isDisconnecting,
    isLoading,
    error,
  }
}
